// extracted by mini-css-extract-plugin
export default {"mainOuter":"styles_mainOuter__I1RSr","main":"styles_main__EKDh9","content":"styles_content__Nl+rT"};